// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__OpK72","left":"StickyBox_left__7aCqI","right":"StickyBox_right__3gDti"};